import Devices from './devices';
import DeviceEdit from './device_edit';
import DevicesBulkEdit from './devices_bulk_edit';
import DeviceView from './device_view';
import DeviceEditGroupMetadata from './edit_group_metadata';
import DeviceViewGroupMetadata from './view_group_metadata';
import UnregisteredDevices from './unregistered_devices';
import CalibrationSection from "./calibration_section";

export {
  Devices,
  DeviceView,
  DeviceEdit,
  DevicesBulkEdit,
  DeviceEditGroupMetadata,
  DeviceViewGroupMetadata,
  UnregisteredDevices,
  CalibrationSection
};
